import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { Button, Card, CardBody, Col } from 'reactstrap';
import imgVerification from '../../../assets/logo/LOGO_CAPBAY_VERTICAL_CROPPED.png';
import { useDict } from '../../../contexts/LanguageContext';
import ROUTE_NAME from '../../../routes/RouteName';

const RegistrationCompletedCard = () => {
    const navigate = useNavigate();

    const dict = useDict();

    const [isResendEmailStatusModalOpen, setIsResendEmailStatusModalOpen] = useState(false);
    const [isResendEmailSuccess, setIsResendEmailSuccess] = useState(false);

    const handleResendEmail = () => {
        // resendActivationEmail(data);
    };

    return (
        <form className="form" style={{ marginTop: '-20px' }}>
            <Col>
                <Card
                    className="pricing-card pricing-card--info"
                    style={{ marginBottom: '-10px !important' }}
                >
                    <CardBody
                        className="pricing-card__body"
                        style={{ padding: '25px 10px' }}
                    >
                        <img
                            className="pricing-card__img_completed"
                            src={imgVerification}
                            alt="capbay-logo"
                        />
                        <h3 className="pricing-card__plan">
                            <b>{dict.registrationCompleted}</b>
                        </h3>
                        <p className="pricing-card__feature">
                            {dict.registrationCompletedContent}
                        </p>
                        {/* {isResendEmailStatusModalOpen &&
                            isResendEmailSuccess && (
                                <Alert
                                    color="success"
                                    className="alert--colored"
                                    icon
                                >
                                    <p
                                        style={{
                                            marginTop: '10px',
                                            textAlign: 'justify',
                                        }}
                                    >
                                        <span className="bold-text">
                                            Successful!{' '}
                                        </span>
                                        Activation email sent to your email.
                                        Please check your email to verify your
                                        email.
                                    </p>
                                </Alert>
                            )}
                        {isResendEmailStatusModalOpen &&
                            !isResendEmailSuccess && (
                                <Alert
                                    color="danger"
                                    className="alert--colored"
                                    icon
                                >
                                    <p
                                        style={{
                                            marginTop: '10px',
                                            textAlign: 'justify',
                                        }}
                                    >
                                        <span className="bold-text">
                                            Oops!{' '}
                                        </span>
                                        We were unable to send the activation
                                        email to your email address. Please try
                                        again.
                                    </p>
                                </Alert>
                            )}
                        <p className="pricing-card__feature">
                            Didn&apos;t get the email?&nbsp;&nbsp;
                            <button
                                type="button"
                                style={{
                                    backgroundColor: '#ffffff',
                                    border: 'none',
                                    color: '#226EF4',
                                    paddingLeft: 0,
                                }}
                                onClick={handleResendEmail}
                            >
                                Resend verification email
                            </button>
                        </p> */}
                        <Button
                            className="pricing-card__button rounded"
                            color="primary"
                            onClick={() => {
                                localStorage.clear();
                                sessionStorage.clear();
                                navigate(ROUTE_NAME.HOME);
                            }}
                            data-cy="registrationCompleted__signInBtn"
                        >
                            {dict.signIn}
                        </Button>
                    </CardBody>
                </Card>
            </Col>
            <div className="account__or_divide" style={{ marginTop: '0px' }}>
                <div className="regulated-by-text">
                    { dict.regulatedByText }
                </div>
            </div>
        </form>
    );
};

export default RegistrationCompletedCard;
